import { Component, OnInit } from '@angular/core';
declare var jquery: any;
declare var $: any;
import { GridOptions } from "ag-grid/main";
import { Globals } from '../../globals';
import { ToastrService } from 'ngx-toastr';
import { CoachService } from 'app/services/coach/CoachService';
import { AdminService, RaterTypeDto } from 'app/services/admin/AdminService';

@Component({
  selector: 'app-c-rater-types',
  templateUrl: './c-rater-types.component.html',
  styleUrls: ['./c-rater-types.component.scss']
})
export class CRaterTypesComponent implements OnInit {

    data: string[] = []; 
    dataHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;

    rowSelection: string;

    canEdit: boolean = false;
    canDelete: boolean = false;

    currentRowIndex: number;
    action: string;
    name: string = '';
    min: number = 3;
    currentRaterId: number;
    loading: boolean = false;

    /*STANDARD RATER TYPEs*/
    standardData: string[] = [];
    standardGridApi;
    isStandard: boolean = false;

    constructor
        (
        private _AdminService: AdminService,
        private _CoachService: CoachService,
        private _Globals: Globals,
        private _toastr: ToastrService
        ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.dataHeaders = this.createHeaders();

        this.getRaterTypesByCoach();
        this.getGlobalRaterTypes();
    }

    getRaterTypesByCoach() {
        this._CoachService.getRaterTypesByCoach().subscribe((data: any) => {
            console.log('response_GetRaterTypesByCoach', data);

            if (this._Globals.validationToken(data.result.Result)) {
                this.data = JSON.parse(data.result.Data);
                console.log('data', this.data);
            }
        });
    }

    getGlobalRaterTypes() {
        this._AdminService.getGlobalRaterTypes().subscribe((data: any) => {
            console.log('response_GetGlobalRaterTypes', data);

            if (this._Globals.validationToken(data.result.Result)) {
                this.standardData = JSON.parse(data.result.Data);
                console.log('data', this.data);
            }
        });
    }

    currentTab(index) {
        console.log(index);
        switch (index) {
            case 1:
                //this.sizeToFit(this.gridApi);
                this.isStandard = false;
                break;
            case 2:
                this.sizeToFit(this.standardGridApi);
                this.isStandard = true;
                break;
        }
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit(this.gridApi);
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    } 

    onStandardGridReady(params) {
        this.standardGridApi = params.api;
        this.sizeToFit(this.standardGridApi);
    } 

    createHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            // headerCheckboxSelection: true,
            // headerCheckboxSelectionFilteredOnly: true,
            // checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        //let minHeader = {
        //    headerName: 'Min',
        //    field: 'Min',
        //    minWidth: 200,
        //    width: 200,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(minHeader);


        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            console.log(data);
            this.openModal('Edit', data['Id'], data['Name']); //, data['Min']);
        }
    }

    public onStandardRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            console.log(data);
        }
    }

    deselectAllCheckBox() {
        this.canEdit = false;
        this.canDelete = false;
        this.gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    onRowSelected(event) {
        console.log("onRowSelected", event);
        this.currentRowIndex = event.rowIndex;
        console.log('currentRowIndex', this.currentRowIndex);
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canEdit = true;
        } else {
            this.canEdit = false;
        }

        if (rowCount == 1) {
            this.canDelete = true;
        } else {
            this.canDelete = false;
        }
    }

    getSelectedRows(): any {
        console.log("SELECTED", this.gridApi.getSelectedRows());
        return this.gridApi.getSelectedRows();
    }

    /*Rater METHODS*/

    openModal(action: string, raterId: number, raterName: string) { //, raterMin: number) {
        this.action = action;
        this.currentRaterId = raterId;
        this.name = raterName;
        //if (!isUndefined(raterMin)) this.min = raterMin;

        $("#createEditModalAdmin").modal({ backdrop: "static" });
        $('#createEditModalAdmin').modal('show');
    }

    closeModal() {
        $('#createEditModalAdmin').modal('hide');
    }

    saveRater() {
        let raterType = new RaterTypeDto;
        raterType.Id = this.currentRaterId;
        raterType.Name = this.name;
        raterType.Min = this.min;
        raterType.IsGlobal = false;

        if (raterType.Name === "") {
            this._toastr.warning("The field name can not be empty.", "ELI");
            return;
        }

        //if (raterType.Min === null || raterType.Min < 0) {
        //    this._toastr.warning("Invalid entry for Min field.", "ELI");
        //    return;
        //}

        this.SaveRaterType(raterType);
    }

    SaveRaterType(raterType: RaterTypeDto) {
        this.loading = true;
        this._AdminService.postSaveRaterType(raterType).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                console.log('data', data);
                //this.getGlobalRaterTypes();
                this.getRaterTypesByCoach();
                this.closeModal();
                this.loading = false;
            }
        })
    }

    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $(`#${tagId}`).val('');
        }
    }

    /*DELETE MODAL*/

    deleteRaterType() {
        this._AdminService.postDeleteRaterType(this.currentRaterId).subscribe((data: any) => {
            console.log('response_DeleteRaterType', data.result.Result);
            if (this._Globals.validationToken(data.result.Result)) {
                switch (data.result.Result) {
                    case 1:
                        this.getRaterTypesByCoach();
                        this.closeModalConfirmation();
                        this.closeModal();
                        this._toastr.success("Relationship deleted successfully", "ELI");
                        break;
                    case 0:
                        this._toastr.error("We are sorry.  An error happened while trying to delete the relationship", "ELI");
                        break;
                    case -1:
                        this._toastr.warning("This relationship cannot be deleted since it is being used in assessment assignments", "ELI");
                        break;
                }
            }
        });
    }

    /*Confirmation Delete*/

    openConfirmationModal() {
        $("#confirmationDeleteModalAdmin").modal({ backdrop: "static" });
        $('#confirmationDeleteModalAdmin').modal('show');
    }

    closeModalConfirmation() {
        $('#confirmationDeleteModalAdmin').modal('hide');
    }

}
